function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.8 12.8" {...props}><title>info</title><g data-name="Ebene 2"><g data-name="Ebene 1"><circle cx="6.4" cy="6.4" r="5.5" fill="none" stroke="#93a7bb" strokeMiterlimit="10" strokeWidth="1.8" /><path d="M6.39 3.16a.89.89 0 0 1 .88.84.87.87 0 0 1-.88.86.85.85 0 0 1-.86-.86.87.87 0 0 1 .86-.84zM5.65 5.49c0-.17.06-.22.27-.22h1c.21 0 .27 0 .27.22v3.69c0 .17-.06.22-.27.22h-1c-.21 0-.27 0-.27-.22z" fill="#93a7bb" /></g></g></svg>;
});